module.exports = __webpack_public_path__ + "static/cliente3-952db82269d24ad02ccda5d45a29df6d.png";